import $ from 'jquery';
// require('waypoints/lib/jquery.waypoints.min.js');
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const $lazyWindow = $(window);

const $innerView = $('.inner-view');

// 外層的lazyLoad
const initLazyLoad = function() {
    function lazyLoadModal() {

        const $detectDom = $('.outer-view .section__base .lazyLoad');

        $detectDom.each(function(index) {
            let $this = $(this); //如果沒有設變數，
            
            // 淡入圖片並移除 lazyLoad class
            gsap.to($this, {
                scrollTrigger: {
                    trigger: $this,
                    start: 'top 300%',
                    onEnter: () => {
                        $this.addClass('opacityDefault');
                        setTimeout(() => {
                            $this.removeClass('lazyLoad');
                        }, 300);

                    },
                    once: true  // ScrollTrigger 只觸發一次
                }
            });

            // 延遲添加 fadeIn 和 animated class
            gsap.to($this, {
                scrollTrigger: {
                    trigger: $this,
                    start: 'top 80%',
                    onEnter: () => {

                        setTimeout(() => {
                            $this.addClass('fadeIn');
                            setTimeout(() => {
                                $this.addClass('animated');
                            }, 300);
                        }, 300);

                    },
                    once: true  // ScrollTrigger 只觸發一次
                }
            });
        })
    }


    //內層圖片載入
    function innerLazyLoadModal() {
        // console.log('hi innerLazyLoadModal!!');
        const $detectDomInner = $('.inner-view .lazyLoad');
        const $innerSection = $('.inner-view .inner-modal');
        // .hasClass('.section__inner4-${i + 1}')
        // const $innerScrollOffsetTop = $innerView.offset().top + $innerView.scrollTop();
        let offsetActivePercent = ($lazyWindow.height() / 2) - 2000; //算出螢幕中間點 + -值，決定載入點

        //innerScroll 
        $innerView.on('scroll', function() {

            //內層scrollTop轉換為外層scrollTop值
            let scrollTop = $innerView.scrollTop() + window.currentInnerOffsetTop[0]; //此陣列在innerModal.js裡宣告與運算
            // console.log('scrollTop', scrollTop);

            //將陣列內的載入點，一個一個抓出來與scrollTop比對
            for (let i = 0; i < window.currentInnerOffsetTop.length; i = i + 1) {
                if (scrollTop > window.currentInnerOffsetTop[i] + offsetActivePercent) {

                    // $(`.section__inner4-${i + 1} .lazyLoad`).removeClass('lazyLoad');
                    // $(`.section__inner4-${i + 1} .lazyLoad`).addClass('fadeIn');

                    // $(`.section__inner${window.dataName}-${i + 1} .lazyLoad`).removeClass('lazyLoad').addClass('fadeIn animated');
                    //階層要多用變數)，讓程式執行時，只要找一次階層，才可提升效能
                    //$xxx.find()只能往下層找，不能找同階層
                    $innerSection.find(`.section__inner${window.dataName}-${i + 1} .lazyLoad`).removeClass('lazyLoad').addClass('fadeIn animated');

                    // console.log('bingo!' ,  $(`.section__inner${window.dataName}-${i + 1} .lazyLoad`));
                    // if ($detectDomInner.hasClass('animated')) {
                    //   console.log('return')
                    //   return;
                    // }
                }
            }


        });
    } // initLazyLoad end


    //IMG tag fade in lazy loaded images
    // $('img').on('load', function() {
    //     $(this).addClass('loaded');
    // });

    lazyLoadModal();
    innerLazyLoadModal();
}

export default initLazyLoad; // 出口 export default 就是把這模組輸出 預設直接執行裡面的 initLazyLoad 這個function




//   $detectDomInner.addClass('opacityDefault');
//   setTimeout(() => {
//     console.log('loadedInner:', $detectDomInner);
//     $detectDomInner.removeClass('lazyLoad');
//     $detectDomInner.addClass('fadeIn');
//   }, 200);

//   setTimeout(() => {
//     $detectDomInner.addClass('animated');
//   }, 700);

// if ($detectDomInner.hasClass('.animated')) { return; }
// }